import {
  DERIVATE_PREVIEW_MEDIUM,
  DERIVATE_PREVIEW_LARGE,
  IMQUERY_POLICY,
} from '../../constants';

import type {
  AssignmentFieldDto,
  DerivateFieldDto,
  MetadataCategoryDto,
  SearchAssetInformationDto,
} from '../dto';

export enum MetadataType {
  DEFAULT,
  DERIVATES,
  ASSIGNMENTS,
}

export interface MetadataProps {
  actualAsset: SearchAssetInformationDto;
  open: boolean;
  setOpen: (open: boolean) => void;
  pinned: boolean;
  setPinned: (pinned: boolean) => void;
}
export interface AssetInformationPanelGroupProps {
  assetInformationGroup: MetadataCategoryDto;
  editMode: boolean;
  addFieldChange: (fieldName: string, value: string) => void;
  actualAsset: SearchAssetInformationDto;
}
export interface MetadataGroupProps {
  metaDataType: MetadataType;
  metaDataPanel: MetadataCategoryDto | DerivateFieldDto | AssignmentFieldDto;
  image?: string;
  fieldType?: string;
  fileId?: string;
}
export interface DerivatePanelGroupProps {
  derivates: DerivateFieldDto[];
}
export interface AssignmentPanelGroupProps {
  assignments: AssignmentFieldDto[];
  image: string;
  reloadMetaData: () => void;
}
export interface ImageRenderer {
  value: string;
}

const _all_policies = [
  DERIVATE_PREVIEW_MEDIUM,
  DERIVATE_PREVIEW_LARGE,
  IMQUERY_POLICY,
] as const;
export type Policy = (typeof _all_policies)[number];

export interface AssetDialogProps {
  open: boolean;
  onClose: () => void;
  product: SearchAssetInformationDto;
}
export interface ImageFromProps {
  sourceImage: Blob;
}
